<div
  class="mat-sort-header-container"
  [class.mat-sort-header-sorted]="isSorted()"
  [class.mat-sort-header-position-before]="arrowPosition == 'before'"
>
  <div class="mat-sort-header-content">
    <ng-content></ng-content>
  </div>

  <!-- Disable animations while a current animation is running -->
  <div
    class="mat-sort-header-arrow"
    *ngIf="renderArrow()"
    [ngStyle]="{ opacity: arrowOpacity }"
    (@arrowPosition.start)="enableAnimation()"
    (@arrowPosition.done)="disableAnimation()"
  >
    <div class="mat-sort-header-stem"></div>
    <div class="mat-sort-header-indicator" [@indicator]="getArrowDirectionState()">
      <div class="mat-sort-header-pointer-left" [@leftPointer]="getArrowDirectionState()"></div>
      <div class="mat-sort-header-pointer-right" [@rightPointer]="getArrowDirectionState()"></div>
      <div class="mat-sort-header-pointer-middle"></div>
    </div>
  </div>
  <div *ngIf="isSorted()">{{ sortId() }}</div>
</div>
